import { render, staticRenderFns } from "./PappersChief.vue?vue&type=template&id=2287992c&scoped=true"
import script from "./PappersChief.vue?vue&type=script&lang=js"
export * from "./PappersChief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287992c",
  null
  
)

export default component.exports